module.exports = __webpack_public_path__ + "img/qydtBanner.5452646c.png";